import React, { Component } from 'react';
import { Container } from 'reactstrap';
import SearchPanel from '@components/SearchPanel/SearchPanel';
import Table from './Table/Table';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import { Helmet } from 'react-helmet';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import AssociationModal from './AssociationModal/AssociationModal';
import { withRouter } from 'react-router';
import FilterModal from './FilterModal/FilterModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@components/Elements/Auth/Auth';

class Associations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phraze: '',
      modalActive: false,
      isFilterModalActive: false
    };

    if (props.list.length === 0) {
      props.getList({}, true);
    }
  }

  componentDidMount = () => {
    document.getElementsByClassName('input-search')[0].click();
    document.getElementsByClassName('input-search')[0].focus();
  };

  onEntityClick = entityId => {
    this.props.history.push(`/associations/${entityId}`);
  };

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  searchTimeout: null;

  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });
    this.searchTimeout = setTimeout(
      () =>
        this.props.getList({
          phraze: value,
          limit: this.props.limit,
          sort: this.props.sort,
          direction: this.props.direction,
          status: this.props.status,
          association_type_id: this.props.association_type_id
        }),
      1000
    );
  };

  render = () => {
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Homeowners Associations</title>
        </Helmet>
        <div className={this.props.loaded ? 'position-relative' : 'd-none'}>
          {this.props.loading && (
            <ProgressBox
              text={'Loading ...'}
              loader={'transparent-background'}
            />
          )}
          <h3>Homeowners Associations</h3>
          <SearchPanel
            showFilter={true}
            createBtn={false}
            searchValue={this.state.phraze}
            onSearchChange={phraze => this.onSearch(phraze)}
            searchPlaceholder={
              'Search by Association name, address or Management Company name'
            }
          >
            <button
              className={'btn btn-transparent'}
              onClick={() => this.toggle('isFilterModalActive')}
            >
              <FontAwesomeIcon icon={['fas', 'filter']} />
            </button>
            <Auth action={'Associations::edit'}>
              <button
                className={'btn btn-primary px-3 ml-3'}
                onClick={() => this.toggle('modalActive')}
              >
                Create New Homeowners Association
              </button>
            </Auth>
          </SearchPanel>
          <Table
            entities={this.props.list}
            onEntityClick={entityId => this.onEntityClick(entityId)}
            {...this.props}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
            showManagementCompany={true}
          />
          <PaginationPanel
            page={this.props.page}
            limit={this.props.limit}
            total={this.props.total}
            start={this.props.start}
            end={this.props.end}
            sort={this.props.sort}
            direction={this.props.direction}
            paginationFunc={this.props.getList}
            phraze={this.state.phraze}
          />

          <FilterModal
            loading={this.props.loading}
            isActive={this.state.isFilterModalActive}
            toggle={() => this.toggle('isFilterModalActive')}
            onFilter={this.props.getList}
            phraze={this.state.phraze}
            associationTypes={this.props.associationTypes}
            {...this.props}
          />
          {this.props.loaded && (
            <AssociationModal
              entity={{}}
              history={this.props.history}
              isActive={this.state.modalActive}
              toggle={() => this.toggle('modalActive')}
              associationTypes={this.props.associationTypes}
            />
          )}
        </div>
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    list: state.association.list,
    page: state.association.page,
    limit: state.association.limit,
    total: state.association.total,
    start: state.association.start,
    end: state.association.end,
    sort: state.association.sort,
    loaded: state.association.loaded,
    direction: state.association.direction,
    loading: state.association.loading,
    status: state.association.status,
    association_type_id: state.association.association_type_id,
    associationTypes: state.auth.association_types
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getList: (getData, hideLoader) =>
      dispatch(actions.getAssociationsList(getData, hideLoader))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Associations)
);
